import { render } from "./UserListLinks.vue?vue&type=template&id=7dd87f9b"
import script from "./UserListLinks.vue?vue&type=script&lang=js"
export * from "./UserListLinks.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./UserListLinks.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/globals/UserListLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dd87f9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dd87f9b', __exports__)) {
    console.log('reload')
    api.reload('7dd87f9b', __exports__)
  }
  
  module.hot.accept("./UserListLinks.vue?vue&type=template&id=7dd87f9b", () => {
    console.log('re-render')
    api.rerender('7dd87f9b', render)
  })

}


export default __exports__